import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=429f1ed0&scoped=true&"
import script from "./CategoryFilter.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=429f1ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f1ed0",
  null
  
)

export default component.exports